module.exports = __webpack_public_path__ + "static/media/news3-2.5732b75c.jpg";